<!--
 * @Descripttion:
 * @Author: liang
 * @Date: 2021-04-20 11:15:47
 * @LastEditors: liang
 * @LastEditTime: 2021-09-13 16:05:34
-->
<template>
  <div class="modal" v-if="show">
    <div class="loginregister">
      <div class="close" @click="close">×</div>
      <div class="title">
        <span v-if="islogin == 1">登 录</span>
        <span v-if="islogin == 2">注 册</span>
        <!-- <span v-if="islogin == 3">忘记密码</span> -->
      </div>
      <el-form ref="form" @keyup.enter.native="login">
        <div class="form">
            <div class="formline">
              <el-input v-model="form.username" placeholder="请您输入账号"></el-input>
              <i class="el-icon-user"></i>
            </div>
            <div class="formline">
              <el-input type="password" v-model="form.password" placeholder="请您输入密码"></el-input>
              <i class="el-icon-unlock"></i>
            </div>
            <!-- <div class="formline" v-if="islogin == 2">
              <el-input v-model="form.password" placeholder="请您确认密码"></el-input>
              <i class="el-icon-unlock"></i>
            </div> -->
            <div class="formline">
              <el-input v-model="form.captcha" placeholder="请您输入验证码"></el-input>
              <i class="el-icon-key"></i>
              <img class="yzmimg" :src="captchaPath" @click="getCaptcha" />
            </div>
            <div class="otheropt">
              <span @click="toother(1)" v-if="islogin == 2 || islogin == 3"
                >前往登录</span
              >
              <!-- <span @click="toother(2)" v-if="islogin == 1 || islogin == 3"
                >新用户注册</span
              > -->
              <span @click="showxy" v-if="islogin == 2 || islogin == 3"
                >注册即表示同意《用户注册协议》</span
              >
              <!-- <span @click="toother(3)" v-if="islogin == 1 || islogin == 2"
                >忘记密码</span
              > -->
            </div>
            <el-button type="primary" :loading="btnload" v-if="islogin == 1" @click="login"
              >登 录</el-button
            >
            <el-button type="warning" :loading="btnload" v-if="islogin == 2"
              >注 册</el-button
            >
            <!-- <el-button type="success" v-if="islogin == 3">修改密码</el-button> -->
        </div>
      </el-form>
    </div>
    <!-- 协议 -->
    <el-dialog
      title="用户注册协议"
      :visible.sync="dialogVisible"
      width="50%"
      :append-to-body="true"
    >
      <div>
        用户注册协议用户注册协议用户注册协议用户注册协议用户注册协议用户注册协议用户注册协议
        用户注册协议用户注册协议用户注册协议用户注册协议用户注册协议用户注册协议用户注册协议
        用户注册协议用户注册协议用户注册协议用户注册协议用户注册协议用户注册协议用户注册协议
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  name: 'loginregister',
  data () {
    return {
      dialogVisible: false,
      islogin: '1',
      show: false,
      btnload: false,
      captchaPath: '',
      form: {
        username: '',
        password: '',
        uuid: '',
        captcha: '',
        loginType: '1'
      }
    }
  },
  computed: {
    dataRule () {
      return {
        username: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        captcha: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getCaptcha()
  },
  methods: {
    init (val) {
      // 弹出登录注册弹框
      // Object.assign(this.$data.form, this.$options.data().form)
      this.form.username = ''
      this.form.password = ''
      this.islogin = val
      this.show = true
    },
    close () {
      // 关闭登录注册弹框
      this.show = false
    },
    toother (val) {
      // 切换登录和注册
      this.btnload = false
      Object.assign(this.$data.form, this.$options.data().form)
      this.islogin = val
    },
    getCaptcha () {
      // 获取验证码
      this.form.uuid = this.getUUID()
      this.captchaPath = `${process.env.VUE_APP_apiURL}/captcha?uuid=${this.form.uuid}`
    },
    getUUID () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
      })
    },
    showxy () {
      // 查看协议
      this.dialogVisible = true
    },
    login () {
      this.btnload = true
      this.$post('/login', this.form).then(res => {
        if (res.code === 0) {
          this.btnload = false
          localStorage.setItem('webtoken', res.data.token)
          Cookies.set('webtoken', res.data.token)
          setTimeout(() => {
            this.getUserInfo()
          }, 100)
        } else {
          this.btnload = false
          this.getCaptcha()
        }
      })
    },
    // 获取当前管理员信息
    getUserInfo () {
      this.$get('/sys/user/info').then(res => {
        if (res.code !== 0) {
          return false
        }
        let userData = JSON.stringify(res.data)
        localStorage.setItem('user', userData)
        this.$emit('getUser')
        this.show = false
        this.$message.success('登录成功！')
        location.reload()

        // if (this.$route.path === '/index') {
        //   location.reload()
        // } else {
        //   this.$router.push('/')
        // }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.modal {
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}
.loginregister {
  width: 380px;
  background: #fff;
  position: fixed;
  left: 50%;
  margin-left: -190px;
  top: 200px;
  border-radius: 3px;
  border: 1px solid #eee;
}
.close {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 36px;
  line-height: 48px;
  padding-right: 10px;
  z-index: 2;
  cursor: pointer;
}
.close:hover {
  color: #409eff;
}
.title {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 1px solid #ddd;
}
.form {
  padding: 0 30px;
}
.formline {
  position: relative;
  margin-top: 25px;
}
.formline > i {
  position: absolute;
  z-index: 12;
  color: #999;
  font-size: 20px;
  left: 10px;
  top: 10px;
}
.formline /deep/.el-input__inner {
  padding-left: 36px;
}
.form > button {
  width: 100%;
  margin: 20px 0 30px 0;
}
.otheropt {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}
.otheropt span {
  cursor: pointer;
}
.otheropt span:hover {
  color: #409eff;
}
.yzmimg {
  position: absolute;
  z-index: 23;
  right: 0;
  top: 0;
  height: 40px;
  max-width: 120px;
}
div/deep/.el-dialog__body {
  padding: 10px 20px;
  max-height: 450px;
  overflow-y: auto;
}
</style>
